import { render } from "./OverviewMonthlyStatistics.vue?vue&type=template&id=2258d240"
import script from "./OverviewMonthlyStatistics.vue?vue&type=script&lang=js"
export * from "./OverviewMonthlyStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__